import Invoice from 'components/Invoice/Invoice';

export default Invoice;
